module.exports = __webpack_public_path__ + "static/media/kelly.b2041de4.jpg";